import React from 'react';
import { useTranslation } from 'react-i18next';
import HeroImage from '../Images/Hero.webp';

const Hero = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language; // e.g., 'pl', 'en', 'ar'

  // Local translations
  const heroText = {
    pl: 'Smak, który pokochasz.',
    en: "A taste you'll love.",
    ar: 'طعم ستحبه',
  };

  return (
    <section className="relative w-full">
      {/* Hero image */}
      <img
        src={HeroImage}
        alt={heroText[currentLang] || heroText.en}
        className="w-full h-auto object-cover"
      />

      {/* Overlay content */}
      <div className="absolute right-10 bottom-5 text-[#DC143C] text-right">
        <div className="inline-block bg-white/90 p-5 rounded-2xl shadow-lg">
          <span className="text-3xl font-bold drop-shadow-sm">
            {heroText[currentLang] || heroText.en}
          </span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
